import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Handle initial navigation based on URL parameters
 * This is specifically for handling Stripe returns on iOS
 */
export const useInitialNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Only run once on mount
    console.log('[InitialNavigation] Checking initial URL:', window.location.href);
    console.log('[InitialNavigation] Hash:', window.location.hash);
    console.log('[InitialNavigation] Search:', window.location.search);
    console.log('[InitialNavigation] Current location:', location.pathname);
    
    // Parse hash parameters - handle both #/path?params and #?params formats
    let hashParams = null;
    if (window.location.hash) {
      // Remove the # and any path before the ?
      const hashString = window.location.hash.substring(1); // Remove #
      const queryIndex = hashString.indexOf('?');
      if (queryIndex !== -1) {
        const queryString = hashString.substring(queryIndex + 1);
        hashParams = new URLSearchParams(queryString);
        console.log('[InitialNavigation] Parsed hash params:', queryString);
      }
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    
    // Check for session_id parameter (indicates Stripe return)
    const sessionId = hashParams?.get('session_id') || urlParams.get('session_id');
    const email = hashParams?.get('email') || urlParams.get('email');
    const plan = hashParams?.get('plan') || urlParams.get('plan');
    
    if (sessionId && email) {
      console.log('[InitialNavigation] Found Stripe return parameters:', { sessionId, email, plan });
      console.log('[InitialNavigation] Current path:', location.pathname);
      
      // The hash router should automatically navigate to /signup if the hash is #/signup
      // We just log for debugging
      if (location.pathname.includes('/signup')) {
        console.log('[InitialNavigation] Already on signup page, params should be handled by SignupPage');
      } else {
        console.log('[InitialNavigation] Not on signup page, hash router should handle navigation');
      }
    } else {
      console.log('[InitialNavigation] No Stripe parameters found');
    }
  }, []); // Empty dependency array - only run once
};